import React from 'react'

const Footer = () => (
  <div
    className="bsi"
  >
  </div>
)

export default Footer
